/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import Loading from '../../components/loading/loading.component';
import PropTypes from 'prop-types';
import * as consts from '../../const.js';
import { FormGroup, ControlLabel, FormControl, Grid, Row, Form } from 'react-bootstrap';
import { Button } from 'tc-client-common';
import Notification from '../common/notification/notification.component';
import DocumentStatusService from './document.status.service';
import DatePicker from 'react-bootstrap-date-picker-react16';
import { generateIteratorKey as keygen } from '../../utils/helpers';
import Select from 'react-select';

class DocumentChangeStatusComponent extends React.Component {
  constructor(props) {
    super(props);

    this.hideDocumentStatus = this.hideDocumentStatus.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleSaveDocumentStatus = this.handleSaveDocumentStatus.bind(this);
    this.needsSignDateAndOptInOptOutInput = this.needsSignDateAndOptInOptOutInput.bind(this);

    const { status, statusDate, reason } = props.props;

    this.state = {
      status: status || this.props.currentStatus,
      reason,
      statusDate
    };
  }

  componentDidMount() {
    this.props.loadDocumentStatuses(this.props.consentingGid);
  }

  needsSignDateAndOptInOptOutInput() {
    return this.state.status === 'SIGNED_ON_PAPER' && !this.props.props.signedTimestamp;
  }

  handleStatusChange(option) {
    this.setState(({ status, statusDate }) => {
      const isPrevStatusSignedOnPaper = status === 'SIGNED_ON_PAPER';
      return { status: option.value, statusDate: isPrevStatusSignedOnPaper ? null : statusDate };
    });
  }

  handleSaveDocumentStatus(e) {
    e.preventDefault();

    const { status, statusDate, reason } = this.state;
    const { consentingGid, studyGid, participantId } = this.props;

    if (this.needsSignDateAndOptInOptOutInput()) {
      this.props.goToSoPOptInOptOutStep({
        ...this.props.props,
        consentingGid,
        studyGid,
        participantId,
        status,
        statusDate,
        reason
      });
      return;
    }

    const payload = { documentId: consentingGid, studyGid, participantId, status, reason };

    this.props.saveStatus(payload, true, this.props.participantJourneyGid);
  }

  hideDocumentStatus() {
    this.props.hide();
  }

  render() {
    if (this.props.isLoading) {
      return <Loading />;
    }

    const errorBody = this.props.error && (
      <Row {...keygen()}>
        <Notification type="error" data={this.props.error} />
      </Row>
    );

    const needsSignDateAndOptInOptOutInput = this.needsSignDateAndOptInOptOutInput(),
      handleReasonChange = (e) => {
        const targetValue = e.target.value;
        this.setState(() => ({ reason: targetValue }));
      },
      handleStatusDateChange = (selectedDate) => {
        this.setState(() => ({ statusDate: selectedDate }));
      };

    return (
      <div>
        <Form horizontal id="edit-document-status-form" onSubmit={this.handleSaveDocumentStatus}>
          <Grid id="edit-document-status-grid" fluid>
            {errorBody}
            <Row {...keygen()}>
              <FormGroup controlId="documentStatus">
                <ControlLabel>{consts.STATUS}:</ControlLabel>
                <Select
                  instanceId="document-status"
                  className={'document-status'}
                  name="status"
                  value={{
                    value: this.state.status,
                    label: <span>{consts[this.state.status]}</span>
                  }}
                  onChange={this.handleStatusChange}
                  options={DocumentStatusService.documentStatusesToOptions(
                    this.props.documentStatuses,
                    this.state.status,
                    this.handleStatusChange
                  )}
                  optionClassName="select-option"
                  clearable={false}
                />
              </FormGroup>
            </Row>
            {needsSignDateAndOptInOptOutInput && (
              <Row {...keygen()}>
                <FormGroup controlId="statusDate">
                  <ControlLabel>
                    {consts.SIGNATURE_DATE}
                    <span> * </span>:
                  </ControlLabel>
                  <DatePicker
                    name="statusDate"
                    showClearButton={false}
                    onChange={handleStatusDateChange}
                    value={this.state.statusDate}
                    showTodayButton
                    required
                  />
                </FormGroup>
              </Row>
            )}
            <Row>
              <FormGroup controlId="reason">
                <ControlLabel>
                  {consts.CHANGE_STATUS_REASON}
                  <span> * </span>:
                </ControlLabel>
                <FormControl
                  componentClass="textarea"
                  id="reason"
                  name="reason"
                  value={this.state.reason}
                  onChange={handleReasonChange}
                  required
                />
              </FormGroup>
            </Row>
          </Grid>
          <div className="edit-modal-footer">
            <hr className="edit-modal-divider" />
            <Button
              id="edit-document-status-cancel-button"
              type="reset"
              theme="default large-button"
              handleClick={this.hideDocumentStatus}
              label={consts.CANCEL_BTN}
            />
            {needsSignDateAndOptInOptOutInput ? (
              <Button
                id="edit-document-status-next-button"
                theme="active large-button"
                label={consts.NEXT_BTN}
                type="submit"
              />
            ) : (
              <Button
                id="edit-document-status-save-button"
                theme="active large-button"
                label={consts.SAVE_BTN}
                type="submit"
              />
            )}
          </div>
        </Form>
      </div>
    );
  }
}

DocumentChangeStatusComponent.propTypes = {
  consentingGid: PropTypes.string,
  error: PropTypes.object,
  currentStatus: PropTypes.string,
  isLoading: PropTypes.bool,
  hide: PropTypes.func,
  documentStatuses: PropTypes.array,
  loadDocumentStatuses: PropTypes.func,
  saveStatus: PropTypes.func,
  studyGid: PropTypes.string.isRequired,
  participantId: PropTypes.number.isRequired
};

export default DocumentChangeStatusComponent;
